
import { Component, Vue, Watch } from 'vue-property-decorator';
import {AxiosStatic} from "axios";
import IResource from "@/IResource";
import IOrganisation from "@/IOrganisation";
import IOrganisationAvailability from "@/IOrganisationAvailability";
import StepMultiTime from "@/components/organisation/StepMultiTime.vue";
import StepData from "@/components/reservation/StepData.vue";
import StepConfirmation from "@/components/reservation/StepConfirmation.vue";
import SingledayCalendar from "@/components/reservation/SingledayCalendar.vue";
import ReservationFooter from "@/components/reservation/ReservationFooter.vue";

@Component({
	components: {
		StepConfirmation,
		StepData,
		StepMultiTime,
		SingledayCalendar,
		ReservationFooter
	},
})
export default class OrganisationMain extends Vue {

	public $http!: AxiosStatic;

	public showLoadingError: boolean = false;

	public availability: IOrganisationAvailability = {};

	get step() {
		return this.$store.state.step;
	}

	get organisation(): IOrganisation {
		return this.$store.state.organisation;
	}

	get singleDayResources(): IResource[] {
		if (this.organisation && this.organisation.resources) {
			return this.organisation.resources.filter(res => res.type === 'singleday')
		}
		return [];
	}

	public mounted() {
		this.loadOrganisation();
		this.loadAvailability();
	}

	public async loadOrganisation() {
		try {
			const response = await this.$http.get(`/public/organisation/${this.$store.state.organisationhash}`);
			this.$store.commit('SET_ORGANISATION', response.data);
			// inject css
			if (response.data.css) {
				let element = document.getElementById('custom_css');
				if (element) {
					element.innerHTML = response.data.css;
				}
			}
		} catch (e) {
			this.showLoadingError = true;
		}
	}

	public async loadAvailability() {
		try {
			let rangeStart = new Date();
			rangeStart.setMonth(rangeStart.getMonth() - 1, 15);
			let rangeEnd = new Date();
			rangeEnd.setMonth(rangeEnd.getMonth() + 6, 31);

			// load availability for the next 6 months (enough for single and multiday calendars)
			let url = '/public/organisation/' + this.$store.state.organisationhash + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
			let response = await this.$http.get(url);
			this.availability = response.data;

			// load availability for the next 15 years
			rangeEnd.setMonth(rangeEnd.getMonth() + (12 * 15));
			url = '/public/organisation/' + this.$store.state.organisationhash + '/availability?start=' + rangeStart.toISOString().substring(0,10) + '&end=' + rangeEnd.toISOString().substring(0,10);
			response = await this.$http.get(url);
			this.availability = response.data;

		} catch (e) {
			this.showLoadingError = true;
		}
	}

	public onSelectDate(date: Date) {
		this.$store.commit('SET_STARTDATE', date);
		this.$store.commit('SET_ENDDATE', date);
		this.$store.commit('SET_STEP', 'step2')
	}

	public onSelectResource(data: { totime: number, fromtime: number, id: number }) {
		let resources = this.singleDayResources.filter(resource => resource.id == data.id);
		if (resources.length > 0) {
			this.$store.commit('SET_FROMTIME', data.fromtime);
			this.$store.commit('SET_TOTIME', data.totime);
			this.$store.commit('SET_RESOURCE', resources[0]);
			this.$store.commit('SET_STEP', 'step3')
		}
	}

	public goToStep1(): void {
		this.$store.commit('SET_STEP', 'step1')
	}

	public goToStep2(): void {
		this.$store.commit('SET_STEP', 'step2')
	}
}
